/* eslint-disable @typescript-eslint/naming-convention */
import React, { useMemo } from "react";
import { useHistory } from "react-router-dom";
import { Data } from "../../../store/cardType/types";
import { MRT_ColumnDef, MaterialReactTable } from "material-react-table";
import TableActions from "../../../common/table/TableActions";

interface Props {
  cardTypeData?: Data[];
}

interface RowData {
  id: string;
  type: string;
  ProductID: string;
  ProductCategory: string;
}

const mapDataToTable = (cardType) => {
  return cardType;
};

export default function CardTypeTable({ cardTypeData }: Props) {
  const history = useHistory();

  const data = mapDataToTable(cardTypeData);

  const editAction = (rowData: RowData) => {
    history.push(`/cardType/edit/${rowData.id}`);
  };

  const viewAction = (rowData: RowData) => {
    history.push(`/cardType/view/${rowData.id}`);
  };

  const columns = useMemo<MRT_ColumnDef<RowData>[]>(
    () => [
      {
        header: "CardType",
        accessorKey: "type"
      },
      {
        header: "Product Id",
        accessorKey: "ProductID"
      },
      {
        header: "Category",
        accessorKey: "ProductCategory"
      },
    ],
    []
  );

  return (
    <MaterialReactTable
      columns={columns}
      data={data}
      getRowId={(row) => row.id}
      initialState={{
        showGlobalFilter: true,
        showColumnFilters: false,
        density: "spacious",
      }}
      enableColumnActions={false}
      enableDensityToggle={false}
      enableFullScreenToggle={false}
      enableColumnFilters={false}
      enableHiding={false}
      enableRowActions
      muiTablePaginationProps={{
        rowsPerPageOptions: [5, 10, 20],
      }}
      displayColumnDefOptions={{
        "mrt-row-actions": {
          header: "",
          size: 100,
        },
      }}
      positionActionsColumn="last"
      renderRowActions={({ row }) => (
        <TableActions
          section="Cert"
          onView={() => viewAction(row.original)}
          onEdit={() => editAction(row.original)}
        />
      )}
    />
  );
}
